import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

/**
 * Type casts Abstract controls to FormControl Type
 */
@Pipe({ name: 'apFormControl' })
export class ApFormControlPipe implements PipeTransform {
    transform(value: AbstractControl): FormControl {
        return value as FormControl;
    }
}
